import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { ReducerEntityPrefixTypes, ReducerNamespaceTypes } from "enums";
import { type TagsPayloadCamelPlural } from "interfaces/Tags";
import { type CampaignTagsState } from "../../types/state";

const initialState: CampaignTagsState = {
  tags: {},
  error: undefined,
};

const campaignTagsSlice = createSlice({
  name: `${ReducerNamespaceTypes.Library}/${ReducerEntityPrefixTypes.ThreatDefenceCampaigns}/tags`,
  initialState,
  reducers: {
    gotTags(state: CampaignTagsState, action: PayloadAction<TagsPayloadCamelPlural>) {
      state.tags = action.payload;
    },
    errTags(state: CampaignTagsState, action: PayloadAction<Error>) {
      state.error = action.payload;
    },
    resetTags: (state: CampaignTagsState) => {
      state.tags = initialState.tags;
    },
  },
});

export const { gotTags, errTags, resetTags } = campaignTagsSlice.actions;

export default campaignTagsSlice.reducer;
